// ==============================================
// ==================Import======================
// ==============================================

//  ===============React hooks==============
import { useSelector } from 'react-redux';

// ===========Components====================
import Spinner2 from '../../Spinner2';

// ==================Style&IMG===================
import './style.scss';

function DOI() {
// ================HOOK==========================
  const data = useSelector((state) => state.metadata.data.dataDoi.DOIAndLicence);
  const display = useSelector((state) => state.metadata.data.dataDoi.displayDOI);

  return (
    <>
      {(!display) && <Spinner2 />}
      {(display)
      && (
        <>
          <div className="metatitle"><span>DOI & License</span></div>
          <div className="doi--list">
            <div>
              <div>
                {(data.properties.doi === 'None')
                  && (
                    <p><span className="name"><b>DOI : {data.properties.doi}</b></span></p>
                  )}
                {(data.properties.doi !== 'None')
                  && (
                    <p><span className="name"><b>DOI : </b><a href={data.properties.doi} target="_blank" rel="noreferrer">{data.properties.doi}</a></span></p>
                  )}

                <p><span className="name"><b>License : </b></span><a href={data.properties.license_link} target="_blank" rel="noreferrer">{data.properties.license}</a></p>
              </div>
            </div>
            {(data.properties === null)
              && (
              <div>
                <div>
                  <p><span className="name"><b>DOI : </b></span>N/A</p>
                  <p><span className="name"><b>License : </b></span>N/A</p>
                </div>
              </div>
              )}
          </div>
        </>
      )}
    </>
  );
}

export default DOI;
